import { useCallback } from 'react';
import { useComponentConfig, useComponentMethods, useComponentTranslations } from 'js/hooks/component';

import * as server from '../server';
import * as actions from '../store/actions';
import { HAVE_COPY_ID_FAX_VALUE, VERIFIED_STATUS } from '../constants';
import { useDynamicReducerDispatch, useDynamicReducerSelector } from '../store';
import { usePossibleVerificationStatuses } from './usePossibleVerificationStatuses';

export const useGetVerificationStatus = () => {
    const { playerTag } = useComponentConfig();
    const translate = useComponentTranslations();
    const dispatch = useDynamicReducerDispatch();
    const { showComponentError } = useComponentMethods();
    const { haveCopyIDFax } = useDynamicReducerSelector();
    const possibleVerificationStatuses = usePossibleVerificationStatuses();

    return useCallback(async () => {
        if (!haveCopyIDFax) {
            return;
        }

        if (haveCopyIDFax === HAVE_COPY_ID_FAX_VALUE.VERIFIED) {
            dispatch(actions.setVerificationStatus(VERIFIED_STATUS));

            return;
        }

        const response = await server.getVerificationStatus({ tagName: playerTag });
        const { tags } = response.data;
        const identtTag = tags.find((tag) => tag.name === playerTag);

        const verificationStatus = possibleVerificationStatuses
            .find((status) => status.value === identtTag?.value);

        if (!verificationStatus) {
            showComponentError(translate('status.disabled'));

            return;
        }

        dispatch(actions.setVerificationStatus(verificationStatus));
    }, [
        translate, playerTag, dispatch, haveCopyIDFax,
        showComponentError, possibleVerificationStatuses
    ]);
};
